import { Grid, Stack, Typography } from "@mui/material";
import get from "lodash/get";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import MainLayout from "../../components/MainLayout";
import service from "../../services/unit";
import LoadingPage from "../LoadingPage";

export default function UnitDetail() {
  const { id } = useParams();
  const { data, isLoading } = useQuery(
    "current-unit",
    () => service.getUnitById(Number(id))
  );

  return isLoading ? (
    <LoadingPage />
  ) : (
    <MainLayout>
      <Breadcrumb
        label={get(data, "data.unit.name") || ""}
        breadcrumbs={[
          { label: "Properties", href: `/app/properties/property` },
          { label: `Property ${get(data, "data.unit.property_name")}`, href: `/app/properties/property/detail/${get(data, "data.unit.property_id")}` },
          { label: `Room ${get(data, "data.unit.room_name")}`, href: `/app/properties/property/room/detail/${get(data, "data.unit.room_id")}` },
          { label: `Unit ${get(data, "data.unit.name")}`, href: `/app/properties/property/unit/detail/${id}` },
        ]}
      />

      <Grid container spacing={2}>
        <Grid item lg={6} xs={12}>
          <Stack sx={{ mt: 2 }}>
            <Typography variant="body1" color="grey.600" fontWeight="300">
              Name
            </Typography>
            <Typography
              variant="body1"
              color="green"
              fontWeight="700"
              sx={{ mt: 0.3 }}
            >
              {data?.data?.unit?.name}
            </Typography>
          </Stack>
          <Stack sx={{ mt: 2 }}>
            <Typography variant="body1" color="grey.600" fontWeight="300">
              Room Name
            </Typography>
            <Typography
              variant="body1"
              color="green"
              fontWeight="700"
              sx={{ mt: 0.3 }}
            >
              {data?.data?.unit?.room_name}
            </Typography>
          </Stack>
          <Stack sx={{ mt: 2 }}>
            <Typography variant="body1" color="grey.600" fontWeight="300">
              Description
            </Typography>
            <Typography
              variant="body1"
              color="green"
              fontWeight="700"
              sx={{ mt: 0.3 }}
            >
              {data?.data?.unit?.description}
            </Typography>
          </Stack>
        </Grid>

        <Grid item lg={6} md={12}>
          <Stack sx={{ mt: 2 }}>
            <Typography variant="body1" color="grey.600" fontWeight="300">
              Length
            </Typography>
            <Typography
              variant="body1"
              color="green"
              fontWeight="700"
              sx={{ mt: 0.3 }}
            >
              {`${data?.data?.unit?.length} m`}
            </Typography>
          </Stack>

          <Stack sx={{ mt: 2 }}>
            <Typography variant="body1" color="grey.600" fontWeight="300">
              Width
            </Typography>
            <Typography
              variant="body1"
              color="green"
              fontWeight="700"
              sx={{ mt: 0.3 }}
            >
              {`${data?.data?.unit?.width} m`}
            </Typography>
          </Stack>

          <Stack sx={{ mt: 2 }}>
            <Typography variant="body1" color="grey.600" fontWeight="300">
              Status
            </Typography>
            <Typography
              variant="body1"
              color="green"
              fontWeight="700"
              sx={{ mt: 0.3 }}
            >
              {data?.data?.unit?.status}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </MainLayout>
  );
}
